// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountModel {
    static getAttributeTypeMap() {
        return AccountModel.attributeTypeMap;
    }
}
AccountModel.discriminator = undefined;
AccountModel.additionalProperties = false;
AccountModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "displayId",
        "baseName": "displayId",
        "type": "string"
    },
    {
        "name": "accountType",
        "baseName": "accountType",
        "type": "AccountType"
    },
    {
        "name": "accountStatus",
        "baseName": "accountStatus",
        "type": "AccountStatus"
    },
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "securePartyId",
        "baseName": "securePartyId",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "assignedUser",
        "baseName": "assignedUser",
        "type": "number"
    },
    {
        "name": "lastModifiedBy",
        "baseName": "lastModifiedBy",
        "type": "number"
    },
    {
        "name": "lastModifiedTime",
        "baseName": "lastModifiedTime",
        "type": "Date"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "accountAddresses",
        "baseName": "accountAddresses",
        "type": ""
    },
    {
        "name": "accountPhoneNumbers",
        "baseName": "accountPhoneNumbers",
        "type": ""
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": ""
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": ""
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": ""
    },
    {
        "name": "accountSessions",
        "baseName": "accountSessions",
        "type": ""
    },
    {
        "name": "voicemailOptInStatus",
        "baseName": "voicemailOptInStatus",
        "type": ""
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": ""
    },
    {
        "name": "assignmentOfBenefitFlag",
        "baseName": "assignmentOfBenefitFlag",
        "type": "boolean"
    },
    {
        "name": "accountContacts",
        "baseName": "accountContacts",
        "type": ""
    },
    {
        "name": "isIneligibleForMailInClaims",
        "baseName": "isIneligibleForMailInClaims",
        "type": "boolean"
    },
    {
        "name": "linkedPayors",
        "baseName": "linkedPayors",
        "type": ""
    },
    {
        "name": "allowAutoReenroll",
        "baseName": "allowAutoReenroll",
        "type": "boolean"
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": ""
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": ""
    },
    {
        "name": "optionalServices",
        "baseName": "optionalServices",
        "type": ""
    },
    {
        "name": "accountServices",
        "baseName": "accountServices",
        "type": ""
    },
];
//# sourceMappingURL=accountModel.js.map